import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "d-flex display-orders" }

import {useDisplayStore} from "@/store/DisplayStore"
import { onBeforeUnmount } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'Display',
  setup(__props) {

const displayStore = useDisplayStore();
displayStore.start();

onBeforeUnmount(() => {
    displayStore.stop();
});
// displayStore.getOrders();

// setInterval(()=>{
//     displayStore.refresh();
// },2000);


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(displayStore).orders, (order) => {
      return (_openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["display-order", { finished: order.isFinished}]),
        key: order.id
      }, [
        _createElementVNode("h1", null, _toDisplayString(order.id), 1)
      ], 2))
    }), 128))
  ]))
}
}

})